import React, { FunctionComponent, useEffect, useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import SliderTitleOffer from './SliderTitleOffer';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import usePrice from '../../../../../../gqlCommon/hooks/prices/usePrice';
import useCarPrices from '../../../../../hooks/prices/useCarPrices';
import { selectedCurrencyVar } from '../../../../../../gqlCommon/graphql/cache';
import useStockUrl from '../../../../../hooks/navigation/useStockUrl';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

const SliderTitleOfferContainer: FunctionComponent = () => {
  const { selectedCar } = useCustomizeCarContext();
  const carData = selectedCar?.car;
  const carName = carData?.attributes?.vehicleDisplayName ?? '';
  const [trimName, setTrimName] = useState('');
  const servicePlanPrice = 0;
  const {
    platformConfig: { isComplexModel, stockPage },
  } = usePlatformConfig();
  const { listUrl } = useStockUrl();
  const selectCarPrices = selectedCar?.prices;
  const { primaryPrice } = usePrice(selectCarPrices.carPrice.finalPrice);
  const { totalDiscount } = useCarPrices(selectCarPrices);
  const selectedCurrency = useReactiveVar(selectedCurrencyVar);
  const hasDiscounts = totalDiscount.find(discount => discount?.amount !== 0);
  const isInStock = selectedCar?.stockAvailability;
  const { promotionalLabel2, isPreOrder } = carData?.attributes || {};

  useEffect(() => {
    if (carData) {
      const currentTrimLabel = carData.trim.attributes.label ?? '';
      const currentVariantName = selectedCar?.car?.variant?.attributes.name ?? '';
      setTrimName(`${currentTrimLabel} ${currentVariantName}`);
    }
  }, [carData]);

  return (
    <SliderTitleOffer
      title={`${isComplexModel ? carName : trimName}`}
      stockLink={{
        label: 'trans__configurator__stock__view_stock_link',
        url: listUrl,
      }}
      hasStock={stockPage}
      hasOffer={false}
      fullPrice={primaryPrice.money.amount + (servicePlanPrice || 0)}
      offerPrice={primaryPrice.money.amount + (servicePlanPrice || 0)}
      currency={selectedCurrency}
      totalDiscount={hasDiscounts ? totalDiscount : null}
      isInStock={isInStock}
      isPreOrder={isPreOrder}
      deliveryTimeFrame={selectedCar.deliveryTimeFrame}
      promotionalLabel={promotionalLabel2}
    />
  );
};

export default SliderTitleOfferContainer;
